import React from 'react';
import { discountPercentPlate, discountPercentPlateText, percentValue } from './styles';
import { Typography } from 'fronton-react';

type ProductDiscountPercentProps = {
  percent?: number | null;
};

export const ProductDiscountPercent: React.FC<ProductDiscountPercentProps> = ({ percent }) => {
  const percentView = percent ? (percent * 100).toFixed() : '';

  return (
    <div data-qa="discountPercentPlate">
      <Typography
        overrideStyles={false}
        className={discountPercentPlate}
        variant="minor"
        color="text-invert"
        size="caption_accent"
      >
        <span className={percentValue}>&minus;{percentView}</span>{' '}
        <span className={discountPercentPlateText}>%</span>
      </Typography>
    </div>
  );
};
